import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Screen } from '../components/layout';
import { ListingGrid, ListingGridSkeleton } from '../components/listing';
import { Button, EmptyState, ErrorState } from '../components/ui';
import { useFavorites } from '../lib/queries';

export function FavoritesPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { data, isLoading, error, refetch } = useFavorites();
  return (
    <Screen title={t('nav.favorites')}>
      {isLoading ? (
        <ListingGridSkeleton />
      ) : error ? (
        <ErrorState error={error} onRetry={() => void refetch()} />
      ) : !data?.length ? (
        <EmptyState icon="heart" title={t('favorites.empty')} text={t('favorites.emptyText')} action={<Button onClick={() => navigate('/search')}>{t('favorites.browse')}</Button>} />
      ) : (
        <ListingGrid items={data.map((i) => ({ ...i, isFavorite: true }))} />
      )}
    </Screen>
  );
}
